import { createRouter, createWebHistory } from 'vue-router'
// import HomeView from '../views/HomeView.vue'
import SelectorView from '@/views/SelectorView'
import LoginView from '@/views/LoginView'
import ScanerView from '@/views/ScanerView'
import ScanLoginView from '@/views/ScanLoginView'

const routes = [
	{
		path: '/',
		name: 'exhibSelector',
		component: SelectorView
	},
	{
		path: '/login',
		name: 'login',
		component: ScanLoginView
	},
	{
		// path: '/scaner/:id/:event_id',
		path: '/scaner',
		name: 'scaner',
		component: ScanerView
	}
	// {
	// 	path: '/',
	// 	name: 'home',
	// 	component: HomeView
	// },
	// {
	// 	path: '/about',
	// 	name: 'about',
	// 	// route level code-splitting
	// 	// this generates a separate chunk (about.[hash].js) for this route
	// 	// which is lazy-loaded when the route is visited.
	// 	component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
	// }
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes
})

export default router
